import {
  Feature,
  FeatureCategory,
  FeatureSummary,
} from "@/lib/types/features.ts";
import * as S from "./styles.ts";
import { Accordion2, UniversalLink } from "@template/components";

interface IFeaturesSideMenuProps {
  categories: FeatureCategory[];
  featureList: FeatureSummary[];
  activeCategoryId: number;
}

const categoryOrder = [
  "Call Handling",
  "Call Management",
  "AI Call Features",
  "Apps and Devices",
  "Collaboration",
  "Analytics",
  "Workflow Enhancement",
  "Admin",
  "Domain Features",
];

const formatTitle = (title: string) =>
  title.replace("Business Phone Systems - ", "").replace(/<\/?[^>]+(>|$)/g, "");

const renderLinks = (
  featureList: FeatureSummary[],
  category: FeatureCategory
) => {
  const currentCategoryFeatures = featureList?.filter(
    (feature) => feature.category_id === category.id
  );
  return currentCategoryFeatures.map((feature) => (
    <UniversalLink
      title={`Learn About ${formatTitle(feature.title)} ${category.category_name} Feature`}
      key={feature.id}
      href={`/${feature.direct_url}`}
      scroll={false}
    >
      {formatTitle(feature.title)}
    </UniversalLink>
  ));
};

const formatCategories = (
  categories: FeatureCategory[],
  featureList: Feature[]
) => {
  return categories
    .filter((category) =>
      featureList.some((feature) => feature.category_id === category.id)
    )
    .filter((category) => category.category_name !== "Reseller Features")
    .sort(
      (a, b) =>
        categoryOrder.indexOf(a.category_name) -
        categoryOrder.indexOf(b.category_name)
    )
    .map((category) => {
      return {
        title: category.category_name,
        content: (
          <S.SideMenuLinksContainer>
            {renderLinks(featureList, category)}
          </S.SideMenuLinksContainer>
        ),
      };
    });
};

export const FeaturesSideMenu = ({
  categories,
  featureList,
  activeCategoryId,
}: IFeaturesSideMenuProps) => {
  const items = formatCategories(categories, featureList);
  const activeCategoryName = categories.find(
    (category) => category.id === activeCategoryId
  )?.category_name;
  const defaultActive = activeCategoryName
    ? items.findIndex((item) => item.title === activeCategoryName)
    : undefined;
  return (
    <S.FeaturesSideMenuContainer>
      <Accordion2
        items={items}
        withArrow={false}
        defaultActiveIndex={
          defaultActive !== undefined && defaultActive > -1
            ? defaultActive
            : undefined
        }
      />
    </S.FeaturesSideMenuContainer>
  );
};
